import { LoaderSpinner } from './ui/LoaderSpinner';

export const LoadingPoint = (): JSX.Element => {
	// const isOffline = typeof navigator !== 'undefined' && !navigator.onLine;
	
	return (
		<div className="flex items-center justify-center grow">
			<LoaderSpinner size={6} />
		</div>
	);
};

